import React, { Fragment } from 'react'
import { Row, Col } from 'antd'

export const CoChairMessage = () => {
  return (
    <Fragment>
      <div className='container page'>
        <h1 className='text-center'>A Message from the Co-chairs</h1>
        <div className='section-inner'>
          <p>
            The University of Calgary Spine Program is a multidisciplinary clinical and
            academic group focused on the care of individuals affected by conditions and
            diseases of the spine and spinal cord.
          </p>
          <p>
            Our mission is to provide world quality health care to individuals with spinal
            disorders through the pursuit of excellence in research, innovation, teaching
            and bedside clinical care. The program is centered at the Foothills Hospital
            and Alberta Children’s Hospital within Alberta Health Services.
          </p>
          <p>
            Members of the Spine Program have joint appointments in the Division of
            Neurosurgery, Department of Clinical Neurosciences and Section of Orthopaedic
            Surgery, Department of Surgery. The Spine Program provides care for patients
            with spinal injury, infection, neoplasia and degenerative diseases. Clinical
            care is closely linked to education and research in a supportive academic
            setting.
          </p>
          <p>
            The program has representation from Neurological Surgery, Orthopaedic Surgery,
            Nursing, and Orthotics. The program offers Spine Surgery Fellowship, combining
            Orthopaedic and Neurosurgical clinical experiences. Both Foothills Medical
            Centre and Alberta Children’s Hospital are tertiary referral centre for the
            entire population of southern Alberta.
          </p>

          <br />
          <Row align='middle' gutter={32}>
            <Col>
              <picture>
                <source
                  srcSet={'/images/team/swamy-and-lewkonia.webp'}
                  type='image/webp'
                />
                <img
                  srcSet={'/images/team/swamy-and-lewkonia.jpg'}
                  alt='portrait'
                  className='team-img'
                />
              </picture>
            </Col>
            <Col>
              <strong>Co-Chairs</strong>
              <br />
              <i>Dr. Ganesh Swamy, Program Lead</i>
              <br />
              and
              <br />
              <i>Dr. Peter Lewkonia, Clinical Lead</i>
            </Col>
          </Row>
        </div>
      </div>
    </Fragment>
  )
}
